// extracted by mini-css-extract-plugin
module.exports = {"root":"ExampleFunctionBar_root__30RoC"};